export const NAV_LINKS = [
  { id: 'home', label: 'Home' },
  { id: 'illustrative', label: 'Illustrative' },
  { id: 'ceramic', label: 'Ceramic' },
  { id: 'painting', label: 'Painting' },
  { id: 'photography', label: 'Photography' },
  { id: 'typography', label: 'Typography' },
  { id: 'contact', label: 'Contact' }
];

export const SECTION_IDS = NAV_LINKS.map(link => link.id);

